export const SET_NOTENEINGABE_STATI = "setNoteneingabeStati";
export const SET_NOTENEINGABE_TYPEN = "setNoteneingabeTypen";